import { AxiosError } from 'axios';
import { useState } from 'react';
import toast from 'react-hot-toast';

import { ErrorHttpResponse, HttpConfig, SuccessHttpResponse } from '../../../models/https';
import useHttps from '../../useHttps';

const useGetDriverPerformance = () => {
    const request = useHttps();
    const [loading, setLoading] = useState(false);
    const [driverBioData, setDriverBioData] = useState<any>(null);

    const onGetDriverPerformanceError = (err: AxiosError<ErrorHttpResponse>) => {
        toast.error(
            err?.response?.data?.message ?? 'Something went wrong while retrieving performance data.',
        );
    };

    const onGetDriverPerformanceSuccess = (callback: () => void) => ({
        data,
        message,
    }: SuccessHttpResponse<any>) => {
        setDriverBioData(data);
        callback();
    };

    const getDriverPerformance = (ninNumber: any, callback: () => void) => {
        const url: HttpConfig = {
            url: `ba/v1/dispatchers/search?query=${ninNumber}`,
            method: 'get',
        };

        request(url, onGetDriverPerformanceSuccess(callback), setLoading, onGetDriverPerformanceError);
    };

    return { getDriverPerformance, loading, driverBioData };
};

export default useGetDriverPerformance;
